import { exec, getApiToken } from '../utils';

interface GetCatalogMediaUploadUrlArgs {
  parentSku: string;
  partnerCode: string;
  token: string;
  fileExtension: string;
  contentType: string;
}

interface CatalogMediaUploadUrlResult {
  uploadUrl: string;
  publicUrl: string;
}

interface GetCatalogMediaUploadUrlResponse {
  restUser: {
    getCatalogMediaUploadUrl: CatalogMediaUploadUrlResult;
  };
}

export const getCatalogMediaUploadUrl = async ({
  parentSku,
  partnerCode,
  token,
  fileExtension,
  contentType,
}: GetCatalogMediaUploadUrlArgs): Promise<CatalogMediaUploadUrlResult> => {
  const apiToken = await getApiToken(token);

  const query = `
    mutation getCatalogMediaUploadUrl(
      $token: String!
      $parentSku: String!
      $partnerCode: String!
      $fileExtension: String
      $contentType: String
    ) {
      restUser(token: $token) {
        getCatalogMediaUploadUrl(
          parentSku: $parentSku
          partnerCode: $partnerCode
          fileExtension: $fileExtension
          contentType: $contentType
        ) {
          uploadUrl
          publicUrl
        }
      }
    }
  `;

  const data = await exec<
    Record<string, unknown>,
    GetCatalogMediaUploadUrlResponse
  >(query, {
    variables: {
      token: apiToken,
      partnerCode,
      parentSku,
      fileExtension,
      contentType,
    },
  });
  return data.restUser.getCatalogMediaUploadUrl;
};
